import * as R from 'ramda'

const config = {
  APP_VERSION: 'dev',
  PHQ_PUBLIC_API_ENDPOINT: '',
  SENTRY_DSN: '',
  SENTRY_ENABLED: false,

  load: function (config) {
    let newConfig = R.merge(this, config)

    // Update existing config
    let self = this

    R.keys(newConfig).map((key) => {
      if (self.hasOwnProperty(key) && typeof self[key] !== 'function') {
        self[key] = newConfig[key]
      }
    })
  }
}

// Handle webpack (dev) .env config
if (typeof process !== 'undefined' && typeof process.env !== 'undefined') {
  let env = {}

  R.mapObjIndexed((value, key) => {
    if (key.startsWith('VUE_APP_')) {
      if (['true', 'false'].includes(value)) {
        // Convert string "true"/"false" to boolean
        env[key.slice('VUE_APP_'.length)] = value === 'true'
      } else {
        env[key.slice('VUE_APP_'.length)] = value
      }
    }
  }, process.env)

  config.load(env)
}

// Handle runtime env.js config
if (typeof window !== 'undefined' && typeof window._runtimeEnv !== 'undefined') {
  // Convert string 1 and 0 to true/false
  let runtimeEnv = {}

  R.map((key) => {
    if (['0', '1'].includes(window._runtimeEnv[key])) {
      runtimeEnv[key] = window._runtimeEnv[key] === '1'
    } else {
      runtimeEnv[key] = window._runtimeEnv[key]
    }
  }, Object.keys(window._runtimeEnv))

  config.load(runtimeEnv)
}

export default config
